export const contactsData = {
    email: 'chinthakindiakshitha@gmail.com',
    // phone: '+919398329527',
    address: 'Hyderabad, Telangana, India ',

    sheetAPI: 'https://sheetdb.io/api/v1/m23u0m53nnhr4'
}